var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "tooltip", staticClass: "tooltip" }, [
    _c("img", {
      staticClass: "tooltip-img",
      attrs: { src: "/images/tooltip_inactive.png" },
      on: { click: _vm.openToolTip },
    }),
    _vm._v(" "),
    _vm.showToolTip
      ? _c(
          "div",
          {
            directives: [
              {
                name: "click-outside-component",
                rawName: "v-click-outside-component",
                value: _vm.closeToolTip,
                expression: "closeToolTip",
              },
            ],
            staticClass: "tooltip-block",
          },
          [
            _c("i", {
              staticClass: "uk-close",
              on: { click: _vm.closeToolTip },
            }),
            _vm._v(" "),
            _vm.indexData
              ? _c("div", { staticClass: "tooltip-block-content" }, [
                  _c(
                    "div",
                    { staticClass: "tooltip-block-title blue-red-hover-text" },
                    [
                      _vm.indexData.ogrn
                        ? _c(
                            "card-link",
                            { attrs: { ogrn: _vm.indexData.ogrn } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.indexData.name_short ||
                                    _vm.indexData.name_full
                                )
                              ),
                            ]
                          )
                        : [
                            _vm.indexData.name_short
                              ? [_vm._v(_vm._s(_vm.indexData.name_short))]
                              : [_vm._v(_vm._s(_vm.indexData.name_full))],
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "tooltip-block-ogrn-inn" }, [
                    _c("b", [_vm._v("ИНН")]),
                    _vm._v(": " + _vm._s(_vm.indexData.inn) + " "),
                    _c("b", [_vm._v("ОГРН")]),
                    _vm._v(
                      ": " + _vm._s(_vm.indexData.ogrn) + "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tooltip-block-date" },
                    [
                      _vm.indexData.date_stop
                        ? [
                            _c("i", {
                              staticClass: "uk-icon-times-circle",
                              staticStyle: { color: "#e74c3c", cursor: "help" },
                              attrs: { title: "Ликвидированно" },
                            }),
                            _vm._v(" "),
                            [
                              _vm._v(
                                " ликвидированно: " +
                                  _vm._s(
                                    new Date(
                                      _vm.indexData.date_stop
                                    ).toLocaleDateString()
                                  )
                              ),
                            ],
                          ]
                        : [
                            _c("i", {
                              staticClass: "uk-icon-check-circle",
                              staticStyle: { color: "#2ecc71", cursor: "help" },
                              attrs: { title: "Действующее" },
                            }),
                            _vm._v(" "),
                            [
                              _vm._v(
                                " зарегистрировано: " +
                                  _vm._s(
                                    new Date(
                                      _vm.indexData.date_start
                                    ).toLocaleDateString()
                                  )
                              ),
                            ],
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.indexData.addr_full
                    ? _c("div", { staticClass: "tooltip-block-address" }, [
                        _c("b", [_vm._v("Адрес:")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.indexData.addr_full) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.indexData.upr[0] &&
                  _vm.indexData.upr.length &&
                  _vm.indexData.upr[0].position
                    ? _c(
                        "div",
                        { staticClass: "tooltip-block-upr" },
                        [
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.lowerButFirst(_vm.indexData.upr[0].position)
                              ) + ":"
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.indexData.upr[0].inn
                            ? [
                                _c(
                                  "person-afil",
                                  {
                                    attrs: {
                                      inn: _vm.indexData.upr[0].inn,
                                      fio: _vm.indexData.upr[0].name,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.onlyFirstLetterBig(
                                          _vm.indexData.upr[0].name
                                        ) +
                                          " (ИНН " +
                                          _vm.indexData.upr[0].inn +
                                          ")"
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            : [_vm._v(_vm._s(_vm.indexData.upr[0].name))],
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tooltip-block-uchr" },
                    [
                      _c("b", [_vm._v("Собственники: ")]),
                      _vm._v(" "),
                      _vm.indexData.uchr && _vm.indexData.uchr.length
                        ? _vm._l(_vm.indexData.uchr, function (e, i) {
                            return _c(
                              "span",
                              { key: i, staticClass: "stay-on-this-row" },
                              [
                                e.ogrn || String(e.inn).length === 10
                                  ? _c(
                                      "card-link",
                                      {
                                        staticClass: "tooltip-link",
                                        attrs: { ogrn: e.ogrn || e.inn },
                                      },
                                      [
                                        _vm._v(_vm._s(e.name)),
                                        e.inn
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(" (ИНН " + e.inn + ")")
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    )
                                  : e.inn && String(e.inn).length !== 10
                                  ? _c(
                                      "person-afil",
                                      {
                                        staticClass: "stay-on-this-row",
                                        attrs: { inn: e.inn, fio: e.name },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.onlyFirstLetterBig(e.name) +
                                              " (ИНН " +
                                              e.inn +
                                              ")"
                                          )
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      { staticClass: "stay-on-this-row" },
                                      [
                                        _vm._v(_vm._s(e.name)),
                                        e.inn
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(" (ИНН " + e.inn + ")")
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                _vm._v(" "),
                                i != _vm.indexData.uchr.length - 1
                                  ? [
                                      _c(
                                        "span",
                                        { staticClass: "stay-on-this-row" },
                                        [_vm._v(", ")]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          })
                        : [_vm._v("-")],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.indexData.okved_title
                    ? _c("div", { staticClass: "tooltip-block-okved" }, [
                        _c("b", [_vm._v("ОКВЭД:")]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.indexData.okved_title) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.indexData.auth_capital
                    ? _c("div", { staticClass: "tooltip-block-capital" }, [
                        _c("b", [_vm._v("Уставный капитал:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.moneyFormat(_vm.indexData.auth_capital)
                            ) +
                            " "
                        ),
                        _c("i", { staticClass: "uk-icon-rub" }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.indexData.fin_years &&
                  _vm.indexData.fin_years.length &&
                  _vm.indexData.viruchka
                    ? _c(
                        "div",
                        { staticClass: "tooltip-block-viruchka" },
                        [
                          _c("b", [
                            _vm._v(
                              "Выручка за " +
                                _vm._s(
                                  _vm.indexData.fin_years[
                                    _vm.indexData.fin_years.length - 1
                                  ]
                                ) +
                                " год:"
                            ),
                          ]),
                          _vm._v(" "),
                          [
                            _vm._v(
                              _vm._s(_vm.moneyFormat(_vm.indexData.viruchka))
                            ),
                          ],
                        ],
                        2
                      )
                    : _vm._e(),
                ])
              : _c("div"),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }